import { Pipe, PipeTransform } from '@angular/core';
import { parseOnlyLetter } from '@app/pipes/mappers/parse-only-letterss.mapper';

@Pipe({
  name: 'onlyLettersValue',
  standalone: false
})
export class OnlyLettersPipe implements PipeTransform {

  constructor() { }

  transform(value: string): string {
    return parseOnlyLetter(value);
  }
}
